import styled from '@emotion/styled';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';

import CreateReportButton from './create-report-button';
import { useDashboardDataContext } from './dashboard/dashboard-context';
import { isUserProjectLeadOrOwner } from './right-panel';

import { useUserProfile } from '~/client/hooks/user-profile';
import * as GQL from '~/graphql/generated/client';
import {
  LeftNavMenu,
  LeftNavMenuItem,
  useLeftNavContext,
} from '~c/components/base/left-nav';
import { ProjectDisplayName } from '~c/components/project/project-name-left-nav';
import {
  aiDashboardUtils,
  functionalModelsRouteUtil,
  candidateAgentsDetailsRouteUtil,
} from '~c/routes';

interface Props {
  className?: string;
}

const AgentDetailsLeftNavImpl: React.FC<Props> = ({ className }) => {
  const { matchRoute, navigateTo } =
    candidateAgentsDetailsRouteUtil.useHelper();

  const dashboard = functionalModelsRouteUtil.useHelper();
  const aiDashboard = aiDashboardUtils.useHelper();
  const { project } = useDashboardDataContext();
  const { userProfile } = useUserProfile();

  // Check if user can manage settings
  const canManageSettings = isUserProjectLeadOrOwner(
    project as GQL.Project,
    userProfile?.email ?? ''
  );

  const { state } = useLeftNavContext();
  const { currentRoute } = state;

  const routePrefix = {
    [candidateAgentsDetailsRouteUtil.routePrefix]:
      candidateAgentsDetailsRouteUtil.routePrefix,
  };
  return (
    <LeftNavMenu
      className={className}
      name={routePrefix[currentRoute ?? '']}
      header={{
        showBackButton: true,
        onClick: () =>
          dashboard.navigateTo(
            matchRoute('DATASET_DETAILS') ? 'DATASETS' : 'AGENTS'
          ),
      }}
    >
      <LeftNavMenuItem
        selected={matchRoute('AGENT_DETAILS') || matchRoute('DATASET_DETAILS')}
        icon={DashboardOutlinedIcon}
        onClick={() => navigateTo('AGENT_DETAILS')}
      >
        <ProjectDisplayName />
      </LeftNavMenuItem>
      <LeftNavMenuItem
        selected={false}
        icon={PeopleIcon}
        onClick={() => aiDashboard.navigateTo('PROJECT_MEMBERS')}
      >
        Stakeholders
      </LeftNavMenuItem>
      {canManageSettings && (
        <LeftNavMenuItem
          selected={matchRoute('SETTINGS')}
          icon={SettingsIcon}
          onClick={() => navigateTo('SETTINGS')}
        >
          Settings
        </LeftNavMenuItem>
      )}
      <CreateReportButton />
    </LeftNavMenu>
  );
};

const AgentDetailsLeftNav = styled(AgentDetailsLeftNavImpl)``;

export default AgentDetailsLeftNav;
